import { Sparkles, ShieldCheck, Clock4, Heart } from "lucide-react";

const VALUES = [
  {
    icon: Sparkles,
    title: "Obsessive Detail",
    desc: "Every panel, every seam, every stitch — checked, polished, perfected.",
  },
  {
    icon: ShieldCheck,
    title: "Pro-Grade Products",
    desc: "We invest in the best ceramic systems, polishes and pH-safe chemicals on the market.",
  },
  {
    icon: Clock4,
    title: "On-Time, Every Time",
    desc: "Bookings are honoured to the minute. Your time matters as much as your finish.",
  },
  {
    icon: Heart,
    title: "Treated Like Ours",
    desc: "Trim taped, wheels glove-handled, paint depth measured before correction. No shortcuts.",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 noise-overlay"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Left — story */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="red-bar" />
              <span className="font-mono-accent text-xs text-zinc-400">04 — ABOUT REVIVE</span>
            </div>
            <h2 className="font-display font-bold uppercase text-white text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tighter mb-10">
              Where <span className="chrome-text">passion</span> meets <span className="text-[#DC2626]">polish</span>.
            </h2>
            <div className="space-y-6 text-zinc-300 text-base md:text-lg leading-relaxed max-w-2xl">
              <p>
                Revive Pro Detailing started in a single garage with one idea: every car deserves to feel
                new again. Today we operate out of a fully-equipped studio, but the obsession that
                started it all hasn't moved an inch.
              </p>
              <p>
                We're certified ceramic coating installers, trained paint-correction specialists,
                and — most importantly — car people. We've owned daily drivers, modified weekend
                cars, and concours show pieces. We get it. So we treat every booking like it's our own.
              </p>
              <p className="text-white font-display uppercase tracking-wide text-xl">
                No shortcuts. No "good enough". Just the best finish your car has worn since the showroom.
              </p>
            </div>
          </div>

          {/* Right — values */}
          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {VALUES.map((v, i) => {
              const Icon = v.icon;
              return (
                <div
                  key={v.title}
                  data-testid={`value-${i}`}
                  className="bg-[#121212] border border-[#27272A] hover:border-[#DC2626] transition-colors p-6 group"
                >
                  <Icon className="h-7 w-7 text-[#DC2626] mb-4 group-hover:scale-110 transition-transform" />
                  <h3 className="font-display font-bold uppercase text-white text-xl tracking-tighter mb-2">
                    {v.title}
                  </h3>
                  <p className="text-zinc-400 text-sm leading-relaxed">{v.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
